/**
 * Plays a notification bell sound effect
 */
export const playNotificationSound = (): void => {
  if (typeof window === 'undefined') return;

  try {
    const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();

    // Create gain node for envelope
    const gainNode = ctx.createGain();
    gainNode.gain.setValueAtTime(1, ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 1);
    gainNode.connect(ctx.destination);

    // Main oscillator
    const osc1 = ctx.createOscillator();
    osc1.type = 'triangle';
    osc1.frequency.setValueAtTime(880, ctx.currentTime);
    osc1.connect(gainNode);
    osc1.start();
    osc1.stop(ctx.currentTime + 1);

    // Second harmonic for bell timbre
    const osc2 = ctx.createOscillator();
    osc2.type = 'triangle';
    osc2.frequency.setValueAtTime(1320, ctx.currentTime);
    osc2.connect(gainNode);
    osc2.start();
    osc2.stop(ctx.currentTime + 1);
  } catch (error) {
    console.error('Error playing notification sound:', error);
  }
};
